import { scarpaGray25 } from "@habitech/shared";
import { theme } from "src/styles/themeStyles";
import styled from "styled-components";

export const WrapperTable = styled.div`
  width: 100%;
  margin-top: 30px;
  .MuiDataGrid-root {
    min-height: 200px;
    margin-bottom: 30px;
  }
  .MuiDataGrid-columnHeaderTitle {
    font-weight: bold;
  }
`;

export const WrapperButtons = styled.div`
  button {
    margin: 20px 0px;
    &[data-id="test_export_options"] {
      height: 47px !important;
      margin: 12px 0 0 0;
      width: 220px;
    }
  }
  button[data-id="whatsapp"] {
    background-color: ${theme.color.whatsappColor};
    border: 2px solid ${theme.color.whatsappColor};
    svg path {
      fill: ${scarpaGray25};
    }
  }
`;

export const WrapperButton = styled.div`
  max-width: 250px;
  margin: auto;
  button {
    margin: auto;
  }
`;
export const Counter = styled.div`
  margin-top: 39px;
`;


